const BASE = (process.env.PUBLIC_URL || "") + "/proj/";
const LIGHT = BASE + "logo-brand-light.webp"; // white logo, for dark backgrounds
const DARK = BASE + "logo-brand-dark.webp";   // forest logo, for light backgrounds

export function Logo({ dark = false, className = "" }) {
  return (
    <img
      src={dark ? LIGHT : DARK}
      alt="Synergy Solar — Energizing Life"
      className={`h-10 w-auto ${className}`}
    />
  );
}
